import {
  CLEAR_PODCAST,
  FETCHED_PODCAST,
  FETCHED_PODCASTS,
  START_FETCHING_PODCAST,
  START_FETCHING_PODCASTS,
} from '../actionTypes';

import { PodcastType } from '../../types/AppTypes';

interface InitialState {
  podcasts: PodcastType[];
  loading: boolean;
  error: any;
  message: any;
  podcast: any;
  tablePageSize: number;
  currentPage: number;
}

const initialState: InitialState = {
  podcasts: [],
  loading: false,
  error: null,
  message: null,
  podcast: null,
  tablePageSize: 10,
  currentPage: 1,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action: any) {
  switch (action.type) {
    case START_FETCHING_PODCASTS:
      return {
        ...state,
        podcasts: [],
        error: null,
        message: null,
        loading: true,
      };
    case FETCHED_PODCASTS: {
      const { podcasts, error, message } = action.payload;
      return {
        ...state,
        podcasts,
        error,
        message,
        loading: false,
      };
    }
    case START_FETCHING_PODCAST: {
      return {
        ...state,
        podcast: null,
        error: null,
        message: null,
        loading: true,
      };
    }
    case FETCHED_PODCAST: {
      const { podcast, error, message } = action.payload;
      return {
        ...state,
        podcast,
        error,
        message,
        loading: false,
      };
    }
    case CLEAR_PODCAST: {
      return {
        ...state,
        podcast: null,
        error: null,
        message: null,
        loading: false,
      };
    }
    default:
      return state;
  }
}
